
















































































































import { Vue, Component, Prop, Emit, Inject } from 'vue-property-decorator';
import Hangul from 'hangul-js';

export interface AxListPanelParams {
  attrs: {
    panelTitle: string;
    groupHint: string;
    groupList: string[];
    itemList: string[];
    defaultGroup: number;
  };

  listeners: {
    group: (group: number) => void;
    item: (group: number, idx: number) => void;
    add: () => void;
    search: (text: string) => void;
  };
}

@Component
export default class AxListPanel extends Vue {
  state = {
    group: 0,
    item: 0,
    searchText: ''
  };

  current = {
    item: -1
  };

  @Inject()
  getLoading!: () => boolean;

  async sleep(ms: number) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  async created() {
    while (this.getLoading()) {
      await this.sleep(100);
    }

    await this.initPanel();
  }

  async initPanel() {
    await this.$nextTick();
    this.state.group = this.defaultGroup;

    this.group(this.state.group);
    this.item(this.state.item);
  }

  async mounted() {
    await this.initPanel();
  }

  @Prop({ type: String, default: '리스트' })
  panelTitle!: string;

  @Prop({ type: String, default: '' })
  groupHint!: string;

  @Prop({ type: Array, default: () => [] })
  groupList!: string[];

  @Prop({ type: Array, default: () => [] })
  itemList!: string[];

  @Prop({ type: Number, default: 0 })
  defaultGroup!: number;

  group(group: number) {
    group = group ?? this.state.group;

    this.state.group = group;
    this.$emit('group', group);
  }

  item(idx: number) {
    idx = idx ?? this.state.item;

    this.state.item = idx;
    this.$emit('item', this.state.group, idx);
  }

  @Emit()
  add() {
    return;
  }

  @Emit()
  search(value: string) {
    return value;
  }

  get selectItem() {
    return this.current.item;
  }

  set selectItem(idx: number) {
    if (idx === undefined) {
      const current = this.current.item;
      setTimeout(() => (this.current.item = current), 0);
    }

    this.current.item = idx;
  }

  get searchItem() {
    return this.state.searchText;
  }

  set searchItem(text: string) {
    this.state.searchText = text;

    const item = this.filteredList.findIndex(x => x.value === this.state.item);
    console.log('searchItem', item);
    if (item === -1) {
      this.selectItem = -1;
    } else {
      this.selectItem = item;
    }
  }

  async onItemChanged(item: { text: string; value: number }) {
    this.state.item = item.value;
  }

  get filteredList() {
    const itemList = this.itemList.map((x, idx) => {
      return { text: x, value: idx };
    });

    if (!this.state.searchText.length) return itemList;

    const searcher = new Hangul.Searcher(this.state.searchText.trim());
    return itemList.filter(x => searcher.search(x.text) !== -1);
  }

  get groupVal() {
    return this.groupList?.map((value, idx) => {
      return { text: this.groupHint + value, value: idx };
    });
  }
}
